import React from 'react';
import "./App.css";
import './styles/ada-theme.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from './context/LanguageContext';
import { ThemeProvider } from './context/ThemeContext';
import Layout from './components/layout/Layout';
import ScrollToTop from './components/common/ScrollToTop';
import SplashPage from './pages/SplashPage';
import HomePage from './pages/HomePage';
import ManifestoPage from './pages/ManifestoPage';
import VisionPage from './pages/VisionPage';
import TerritoriesPage from './pages/TerritoriesPage';
import ProjectsPage from './pages/ProjectsPage';
import AboutPage from './pages/AboutPage';
import JoinPage from './pages/JoinPage';
import ConstitutionPage from './pages/ConstitutionPage';
import PosturePage from './pages/PosturePage';
import ApprochePage from './pages/ApprochePage';
import PropositionsPage from './pages/PropositionsPage';
import ActualitesPage from './pages/ActualitesPage';
// New Pages - Upgrade Modules
import ScorecardPage from './pages/ScorecardPage';
import GouvernancePage from './pages/GouvernancePage';
import FAQPage from './pages/FAQPage';
import TransparencePage from './pages/TransparencePage';
import TerrainPage from './pages/TerrainPage';
import NotesPage from './pages/NotesPage';
import EvenementsPage from './pages/EvenementsPage';
import PressePage from './pages/PressePage';
import TribunesPage from './pages/TribunesPage';
// New Pages - Deployment Ready
import DonatePage from './pages/DonatePage';
import DonationSuccessPage from './pages/DonationSuccessPage';
import OrganigramPage from './pages/OrganigramPage';
import LegalPage from './pages/LegalPage';
import ComparaisonPage from './pages/ComparaisonPage';
import AdminPage from './pages/AdminPage';
// Program Section (Legacy - kept for compatibility)
import ProgramPage from './pages/program/ProgramPage';
import BrandedPartiesPage from './pages/program/BrandedPartiesPage';
import HouseOfAlliancePage from './pages/program/HouseOfAlliancePage';
import ShadowCabinetPage from './pages/program/ShadowCabinetPage';
import ProgramChaptersPage from './pages/program/ProgramChaptersPage';

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <div className="App">
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              {/* Splash Landing Page - No Layout */}
              <Route path="/" element={<SplashPage />} />
              
              {/* Main Site Routes - With Layout */}
              <Route path="/accueil" element={<Layout><HomePage /></Layout>} />
              <Route path="/notre-posture" element={<Layout><PosturePage /></Layout>} />
              <Route path="/approche" element={<Layout><ApprochePage /></Layout>} />
              <Route path="/propositions" element={<Layout><PropositionsPage /></Layout>} />
              <Route path="/actualites" element={<Layout><ActualitesPage /></Layout>} />
              <Route path="/rejoindre" element={<Layout><JoinPage /></Layout>} />
              <Route path="/a-propos" element={<Layout><AboutPage /></Layout>} />
              
              {/* New Module Routes */}
              <Route path="/scorecard" element={<Layout><ScorecardPage /></Layout>} />
              <Route path="/notes" element={<Layout><NotesPage /></Layout>} />
              <Route path="/terrain" element={<Layout><TerrainPage /></Layout>} />
              <Route path="/evenements" element={<Layout><EvenementsPage /></Layout>} />
              <Route path="/gouvernance" element={<Layout><GouvernancePage /></Layout>} />
              <Route path="/faq" element={<Layout><FAQPage /></Layout>} />
              <Route path="/transparence" element={<Layout><TransparencePage /></Layout>} />
              <Route path="/presse" element={<Layout><PressePage /></Layout>} />
              <Route path="/tribunes" element={<Layout><TribunesPage /></Layout>} />
              
              {/* Donation Routes */}
              <Route path="/don" element={<Layout><DonatePage /></Layout>} />
              <Route path="/don/succes" element={<Layout><DonationSuccessPage /></Layout>} />
              
              {/* Organization & Legal Routes */}
              <Route path="/organigramme" element={<Layout><OrganigramPage /></Layout>} />
              <Route path="/mentions-legales" element={<Layout><LegalPage /></Layout>} />
              
              {/* Legacy Routes - Kept for compatibility & SEO */}
              <Route path="/manifeste" element={<Layout><ManifestoPage /></Layout>} />
              <Route path="/vision" element={<Layout><VisionPage /></Layout>} />
              <Route path="/territoires" element={<Layout><TerritoriesPage /></Layout>} />
              <Route path="/projets" element={<Layout><ProjectsPage /></Layout>} />
              <Route path="/constitution" element={<Layout><ConstitutionPage /></Layout>} />
              <Route path="/comparaison" element={<Layout><ComparaisonPage /></Layout>} />
              
              {/* Program Section - Legacy */}
              <Route path="/program" element={<Layout><ProgramPage /></Layout>} />
              <Route path="/program/branded-parties" element={<Layout><BrandedPartiesPage /></Layout>} />
              <Route path="/program/house" element={<Layout><HouseOfAlliancePage /></Layout>} />
              <Route path="/program/shadow-cabinet" element={<Layout><ShadowCabinetPage /></Layout>} />
              <Route path="/program/chapters" element={<Layout><ProgramChaptersPage /></Layout>} />
              
              {/* Admin */}
              <Route path="/admin" element={<Layout><AdminPage /></Layout>} />
            </Routes>
        </BrowserRouter>
      </div>
    </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
